import cssHasPseudo from 'css-has-pseudo/browser';
cssHasPseudo(document);

import './components/*';

import $ from 'jquery';

$('.js-highlight').each(function (index, element) {
  const $element = $(element);
  const regex = /(\d+(?!\w))/gi;
  const regexHtml = $element
    .html()
    .replace(regex, '<em class="menu__item-number">$1</em>');
  $element.html(regexHtml);
});
